import { render, staticRenderFns } from "./inquirySeaFclDetail.vue?vue&type=template&id=91e324c6&scoped=true&"
import script from "./inquirySeaFclDetail.vue?vue&type=script&lang=js&"
export * from "./inquirySeaFclDetail.vue?vue&type=script&lang=js&"
import style0 from "./inquirySeaFclDetail.vue?vue&type=style&index=0&id=91e324c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e324c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91e324c6')) {
      api.createRecord('91e324c6', component.options)
    } else {
      api.reload('91e324c6', component.options)
    }
    module.hot.accept("./inquirySeaFclDetail.vue?vue&type=template&id=91e324c6&scoped=true&", function () {
      api.rerender('91e324c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Inquiry/inquirySeaFclDetail.vue"
export default component.exports